import { makeStyles } from "tss-react/mui"
import { Box, IconButton, Typography } from "@mui/material"
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons"
import { faCircleXmark } from "@fortawesome/pro-thin-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { StandardButton } from "../../../../buttons/StandardButton"

const useStyles = makeStyles()((theme) => ({
    header: {
        position: "sticky",
        top: 0,
        zIndex: theme.zIndex.appBar,
        padding: "1rem",
        background: theme.palette.common.white,
        borderBottom: `1px solid ${theme.palette.tailwind.slate[400]}`,
        minHeight: "5.625rem",
        display: "flex",
        alignItems: "center",
        flexShrink: 0,
    },
    left: {
        flex: 1,
        minWidth: 0,
    },
    goBackButton: {
        color: theme.palette.tailwind.slate[900],
    },
    goBackIcon: {
        fontSize: "1rem",
    },
    center: {
        flex: 1,
        display: "flex",
        justifyContent: "center",
        minWidth: 0,
    },
    title: {
        color: theme.palette.tailwind.slate[900],
        fontWeight: 700,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    right: {
        flex: 1,
        display: "flex",
        justifyContent: "flex-end",
    },
    closeIcon: {
        color: theme.palette.tailwind.slate[600],
        fontSize: "2rem",
    },
}))

type TakeawayCheckoutHeaderProps = Readonly<{
    onGoBack: () => void
    onClose: () => void
}>

export function TakeawayCheckoutHeader({ onGoBack, onClose }: TakeawayCheckoutHeaderProps) {
    const { classes } = useStyles()

    return (
        <Box className={classes.header}>
            <Box className={classes.left}>
                <StandardButton
                    variant="text"
                    color="black"
                    fullWidth={false}
                    className={classes.goBackButton}
                    startIcon={<FontAwesomeIcon icon={faArrowLeft} className={classes.goBackIcon} />}
                    onClick={onGoBack}
                >
                    <LocalizedStrict id="takeaway-confirm-order-dialog-go-back-button">
                        <Typography variant="body1">Go Back</Typography>
                    </LocalizedStrict>
                </StandardButton>
            </Box>

            <Box className={classes.center}>
                <LocalizedStrict id="takeaway-confirm-order-dialog-title">
                    <Typography variant="h4" className={classes.title}>
                        Confirm order
                    </Typography>
                </LocalizedStrict>
            </Box>

            <Box className={classes.right}>
                <IconButton onClick={onClose}>
                    <FontAwesomeIcon icon={faCircleXmark} className={classes.closeIcon} />
                </IconButton>
            </Box>
        </Box>
    )
}
